<script>
import {computed, defineAsyncComponent, onMounted, ref} from "vue";
import MdcMenu from "@/components/MdcMenu/MdcMenu";
import MdcSelect from "@/components/MdcSelect/MdcSelect";
import MainNavigation from "@/components/MainNavigation";
import FooterNavToggle from "@/components/FooterNavToggle";
import TranslateIn from "@/components/TranslateIn";
import {windowOrientation} from "@/utils";
import {MDCTextField} from '@material/textfield';
import MdcForm from "@/components/Mdc/MdcForm.vue";

export default {
    components: {
        'mdc-accordion': defineAsyncComponent(() => import("@/components/MdcAccordion/MdcAccordion")),
        'mdc-accordion-item': defineAsyncComponent(() => import("@/components/MdcAccordion/MdcAccordionItem")),
        'news-label': defineAsyncComponent(() => import("@/components/NewsLabel")),
        'home-header': defineAsyncComponent(() => import("@/components/HomeHeader")),
        'challenge-slider': defineAsyncComponent(() => import("@/components/ChallengeSlider")),
        'animated-icons': defineAsyncComponent(() => import("@/components/AnimatedIcons")),
        'image-teaser': defineAsyncComponent(() => import("@/components/ImageTeaser")),
        'to-top': defineAsyncComponent(() => import("@/components/ToTop")),
        MdcMenu,
        MdcSelect,
        MainNavigation,
        FooterNavToggle,
        TranslateIn,
        MdcForm
    },
    setup() {
        const mobileNavOpen = ref(false);

        const toggleMobileNav = (state) => {
            if (state !== undefined) {
                mobileNavOpen.value = state;
            } else {
                mobileNavOpen.value = !mobileNavOpen.value;
            }
            mobileNavOpen.value ?
                document.body.classList.add("page-header__navigation--active") :
                document.body.classList.remove("page-header__navigation--active");
        }

        const modalDefaultContent = ref(null);
        const setModalDefaultContent = (content) => {
            modalDefaultContent.value = content;
        }
        const clearModalDefaultContent = () => {
            modalDefaultContent.value = null;
        }

        const searchOverlay = ref(false);

        const toggleMobileNavClass = computed(() => {
            return {
                'is-active': mobileNavOpen.value
            };
        })
        const isMobile = computed(() => {
            return windowOrientation.value.width < 768;
        });
        const isTabletPortrait = computed(() => {
            return windowOrientation.value.width < 1024;
        });

        const footerMainNav = ref();

        onMounted(() => {
            let textFields = document.querySelectorAll('.mdc-text-field');
            for (let x = 0; x < textFields.length; x++) {
                new MDCTextField(textFields[x]);
            }
        })

        const toggleSearch = () => {
            searchOverlay.value = !searchOverlay.value;
        }

        return {
            isTabletPortrait,
            isMobile,
            toggleMobileNav,
            toggleMobileNavClass,
            toggleSearch,
            searchOverlay,
            modalDefaultContent,
            setModalDefaultContent,
            clearModalDefaultContent
        }
    }
}
</script>

<style lang="scss">
@use "@/scss/main.scss";
</style>
